export interface FAQ {
  question: string;
  answer: string;
}

export const siteFAQs: FAQ[] = [
  {
    question: '初音岛系列一共有几部作品？',
    answer: '初音岛（Da Capo）系列目前包含三部主要正传作品：初音岛无印（2002年）、初音岛II（2006年）和初音岛III（2012年）。此外还有多部Fan Disc和外传作品，如《D.C. Four Seasons》《D.C.II Spring Celebration》等。整个系列由日本游戏公司CIRCUS开发制作。',
  },
  {
    question: '初音岛系列适合新手入门吗？',
    answer: '非常建议从初代初音岛（D.C. ～ダ・カーポ～）开始体验。初代作品是整个系列的基础，世界观设定最为简明易懂，角色塑造也最为经典。如果您喜欢更现代化的画面和系统，也可以从初音岛III入手，不过部分剧情需要前作的知识储备才能完全理解。',
  },
  {
    question: '初音岛有官方中文版吗？',
    answer: '目前初音岛系列的部分作品已在Steam等平台推出了官方中文版本。初代初音岛的高清重制版支持简体中文和繁体中文。建议关注CIRCUS官方渠道获取最新的中文化信息。',
  },
  {
    question: '初音岛的樱花树有什么特殊含义？',
    answer: '樱花树是初音岛系列最核心的象征元素。它拥有实现愿望的魔力，但愿望的实现往往伴随着代价。樱花树代表了"梦想与现实之间的抉择"这一系列核心主题。同时，永不凋零的樱花也象征着永恒的爱与记忆——虽然美好，但违背自然规律的事物终将需要被修正。',
  },
  {
    question: '初音岛系列之间有什么联系？',
    answer: '三部正传作品共享同一个世界观，时间线先后相隔约五十年。初代角色的后代在后续作品中登场，而芳乃樱作为魔法使贯穿全系列。各作品通过"樱花树"这一核心设定相互关联。虽然每部作品都有独立完整的故事，但了解全系列可以更好地理解角色的命运和世界的全貌。',
  },
  {
    question: '如何加入初音岛粉丝社区？',
    answer: '您可以通过本网站的"粉丝社区"栏目了解最新的社区活动信息。我们定期举办线上讨论、同人创作比赛和线下聚会活动。此外，您也可以在微博、B站等平台搜索"初音岛"相关话题，找到志同道合的粉丝朋友。我们欢迎每一位热爱初音岛的朋友加入！',
  },
];

export const siteInfo = {
  name: '初音岛粉丝资讯站',
  slogan: '探索初音岛的一切',
  description: '初音岛是广受欢迎的视觉小说作品，本站为您全面介绍初音岛的剧情、角色、游戏攻略与周边资讯。无论您是新玩家还是资深粉丝，都能在这里找到关于初音岛的最权威、最详尽的内容指南。',
  founded: '2024年',
  email: 'contact@hatsunejima-fans.com',
  address: '上海市浦东新区樱花路88号',
  socialLinks: {
    weibo: 'https://weibo.com/hatsunejima',
    bilibili: 'https://space.bilibili.com/hatsunejima',
  },
};

export const brandStory = {
  title: '关于初音岛粉丝资讯站',
  intro: '初音岛粉丝资讯站成立于2024年，是由一群热爱初音岛系列的中国粉丝共同创建的综合性资讯平台。我们致力于为华语区的初音岛玩家和粉丝提供最全面、最权威、最及时的内容服务。',
  mission: '我们的使命是搭建华语圈最大的初音岛内容中心，让每一位喜欢初音岛的朋友都能在这里找到归属感。无论是初次接触系列的新玩家，还是追随多年的资深粉丝，我们都希望本站能成为您探索初音岛世界的最佳伙伴。',
  values: [
    { title: '热爱驱动', description: '我们的一切工作都源于对初音岛系列的真挚热爱。创作团队中的每一位成员都是初音岛的资深玩家和忠实粉丝。' },
    { title: '内容至上', description: '我们坚持产出高质量的原创内容，从剧情解析到角色分析，每篇文章都经过精心撰写和严格审核。' },
    { title: '社区为本', description: '我们相信粉丝社区的力量。通过线上交流与线下活动，我们希望将散落在各地的初音岛粉丝连接在一起。' },
  ],
  achievements: [
    { number: '50+', label: '原创文章' },
    { number: '10,000+', label: '社区成员' },
    { number: '15+', label: '线下活动' },
    { number: '98%', label: '好评率' },
  ],
};

export const testimonials = [
  {
    name: '樱小路',
    role: '资深玩家',
    content: '这是我见过最用心的初音岛中文资讯站！剧情解析的角度独特而深入，让我对已经通关多次的游戏有了全新的理解。强烈推荐给每一位初音岛粉丝！',
    avatar: 'ri-user-smile-line',
  },
  {
    name: '月下独酌',
    role: '同人创作者',
    content: '作为一个画同人图的画手，这里的角色介绍和设定资料给了我很多创作灵感。社区的交流氛围也非常好，认识了很多志同道合的朋友。',
    avatar: 'ri-palette-line',
  },
  {
    name: '春风十里',
    role: '新玩家',
    content: '通过朋友推荐来到这个网站，作为刚接触初音岛系列的新人，这里的攻略指南帮了我大忙。分类清晰、内容详尽，真的是新手的福音！',
    avatar: 'ri-emotion-happy-line',
  },
];